<template>
  <div class="page-XLvideo">
    <video
      id="myVideo"
      preload="auto"
      loop
      playsinline
      autoplay
      src="../style/mp4/picture2.mp4"
      tabindex="-1"
      muted="muted"
    ></video>
  </div>
</template>

<script>
export default {
  name: "XLvideo",
  methods: {
    init() {
      let that = this;
      var vid = document.getElementById("myVideo");
      vid.addEventListener("canplaythrough", () => {
        that.$emit("upload", true);
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.page-XLvideo {
  height: 40vh;
  overflow: hidden;
}
#myVideo {
  position: absolute;
  left: 50%;
  top: -4%;
  /*保证视频内容始终居中*/
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
  min-height: 800px;
}
</style>
